export enum PaymentCardType {
    Amex = 'Amex',
    Bancomat = 'Bancomat',
    Bancontact = 'Bancontact',
    Bc = 'Bc',
    CarteBleue = 'CarteBleue',
    Dankort = 'Dankort',
    DinersClub = 'DinersClub',
    Discover = 'Discover',
    Eftpos = 'Eftpos',
    Eps = 'Eps',
    Giro = 'Giro',
    Interac = 'Interac',
    Isracard = 'Isracard',
    Jcb = 'Jcb',
    Maestro = 'Maestro',
    MasterCard = 'MasterCard',
    Meps = 'Meps',
    Mir = 'Mir',
    Nets = 'Nets',
    PostFinance = 'PostFinance',
    RuPay = 'RuPay',
    Troy = 'Troy',
    UnionPay = 'UnionPay',
    VPay = 'VPay',
    Verve = 'Verve',
    Visa = 'Visa',
}
